import React, {
  useState,
} from 'react';

import styled from 'styled-components';

const Pixel = styled.span`
  position: fixed;
  width: 0px;
  height: 0px;
`;

export default function ContextMenu({
  children,
  renderContextMenu,
}) {
  const [
    {
      isOpen,
      x,
      y,
    },
    setState,
  ] = useState({ isOpen: false });

  return (
    <>
      {
        React.cloneElement(children, {
          onContextMenu: (event) => {
            event.preventDefault();
            if (!isOpen) {
              setState({
                isOpen: true,
                x: event.pageX,
                y: event.pageY,
              });
            }
          },
        })
      }
      {
        (isOpen && renderContextMenu)
        ? React.cloneElement(
            renderContextMenu(),
            {
              children: <Pixel style={{ left: `${x}px`, top: `${y}px` }} />,
              visible: true,
              onVisibleChange: (visible) => {
                setState({ isOpen: !!visible });
              },
            },
          )
        : null
      }
    </>
  );
}
